/* eslint-disable no-console */
import { ActionReducer, MetaReducer } from '@ngrx/store';

import { environment } from '®environments/environment';
import { ActionBarActionTypes } from '®shared/container-structure/edit/action-bar/action-bar.actions';
import { SectionHoverBarActionTypes } from '®shared/container-structure/view/section-hover-bar/section-hover-bar.actions';

// Toggle this to turn on local Redux logging in the console for all actions & state changes.
const isReduxLoggerEnabled = false;

export const metaReducers: MetaReducer<any>[] =
  isReduxLoggerEnabled && !environment.production ? [debugLogger] : [];

function debugLogger(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    const arrTypesToExclude = [
      '@ngrx/store-devtools/recompute',
      ActionBarActionTypes.UPDATE_HIGHLIGHTED_ACTION_BAR,
      SectionHoverBarActionTypes.UPDATE_HIGHLIGHTED_SECTION_HOVER_BAR,
    ];

    if (!arrTypesToExclude.includes(action.type)) {
      console.groupCollapsed(`Action: ${action.type}`);
      console.log('Action Payload:', (action as any).payload || 'No Payload');
      console.log('State Before:', state);
    }

    const nextState = reducer(state, action);

    if (!arrTypesToExclude.includes(action.type)) {
      console.log('State After:', nextState);
      console.groupEnd();
    }

    return nextState;
  };
}
